import {registerComponent} from '../utils/registry';

export class SimpleCarousel {
    private items: HTMLElement[];
    private images: HTMLElement[];
    private current = 0;
    private intervalId?: number;
    private readonly interval: number;

    constructor(
        containerSelector: string,
        interval = 8000
    ) {
        const container = document.querySelector(containerSelector);
        this.items = container
            ? Array.from(container.querySelectorAll('.carousel-item')) as HTMLElement[]
            : [];

        this.images = Array.from(document.querySelectorAll('.carousel-image-container .carousel-image')) as HTMLElement[];
        this.interval = interval;
    }

    public init(): void {
        if (this.items.length === 0 || this.images.length === 0) {
            console.warn('simpleCarousel: missing slides or images.');
            return;
        }

        // Ensure both first text and first image are visible before cycling
        this.show(0);

        // Auto-rotate
        this.intervalId = window.setInterval(() => this.next(), this.interval);

        // Manual controls
        document.querySelector('[data-slide="next"]')?.addEventListener('click', () => this.next(true));
        document.querySelector('[data-slide="prev"]')?.addEventListener('click', () => this.prev(true));
    }

    private show(index: number): void {
        this.items.forEach((item, i) => {
            const el = item as HTMLElement;
            const active = i === index;
            el.classList.toggle('active', active);
            el.style.display = active ? 'block' : 'none';
        });

        this.images.forEach((img, i) => {
            const el = img as HTMLElement;
            el.style.display = i === index ? 'block' : 'none';
        });

        this.current = index;
    }

    private next(resetTimer = false): void {
        this.current = (this.current + 1) % this.items.length;
        this.show(this.current);
        if (resetTimer) this.resetInterval();
    }

    private prev(resetTimer = false): void {
        this.current = (this.current - 1 + this.items.length) % this.items.length;
        this.show(this.current);
        if (resetTimer) this.resetInterval();
    }

    private resetInterval(): void {
        if (this.intervalId) clearInterval(this.intervalId);
        this.intervalId = window.setInterval(() => this.next(), this.interval);
    }
}

const simpleCarousel = registerComponent('simpleCarousel', new SimpleCarousel('#clients-about-carousel'));
simpleCarousel.init();
